import React from 'react';
import { Shield, X } from 'lucide-react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';

export function AdminViewBanner() {
  const location = useLocation();
  const { hasRole } = useAuth();

  // Only show for admin users
  if (!hasRole('admin')) return null;

  // Determine current portal based on pathname
  let portalName = 'Admin';
  let isAdminPortal = true;
  
  if (location.pathname.startsWith('/buyer')) {
    portalName = 'Buyer';
    isAdminPortal = false;
  } else if (location.pathname.startsWith('/supplier')) {
    portalName = 'Supplier';
    isAdminPortal = false;
  } else if (location.pathname.startsWith('/admin')) {
    portalName = 'Admin';
    isAdminPortal = true;
  }

  return (
    <div className="border-b border-info/20 bg-info/5 px-4 py-2">
      <div className="mx-auto flex max-w-7xl items-center justify-between">
        <div className="flex items-center gap-2 text-sm text-info">
          <Shield className="size-4" />
          <span className="font-medium">Admin Mode:</span>
          <span>Viewing {portalName} Portal</span>
        </div>
        {!isAdminPortal && (
          <button
            onClick={() => {
              window.location.href = '/admin/dashboard';
            }}
            className="flex items-center gap-1 text-sm font-medium text-info transition-colors hover:text-info-foreground"
          >
            Return to Admin Portal
            <X className="size-4" />
          </button>
        )}
      </div>
    </div>
  );
}

